import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface EmailSectionProps {
  email: string;
}

export const EmailSection = ({ email }: EmailSectionProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          value={email}
          disabled
          className="bg-gray-100"
        />
        <p className="text-sm text-muted-foreground">
          This is the email address associated with your account.
        </p>
      </div>
    </div>
  );
};